import React, { Component } from 'react';
import ReactTable from 'react-table';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import { connect } from 'react-redux'
import { setTrue } from '../../actions/refresh'
import printDocument from '../../printDocument'
import { isAdmin } from '../../helpers';
import Config from '../../config';
import axios from 'axios';
moment.tz.setDefault('Europe/Stockholm');
moment.locale('sv');


class ThisStationTable extends Component {
  constructor(props) {
    super(props)

    this.state = {
      name: '',
      data: [],
      token: '',
      loading: false,
      fromContactInfo: {},
      toContactInfo: {},
      locationType: '',
      expanded: {},
      lastOrderId: ''
    }

    this.update = this.update.bind(this);
    this.forceOutgoingConfirmation = this.forceOutgoingConfirmation.bind(this);
    this.sendBackWheel = this.sendBackWheel.bind(this);
  }

  componentDidMount() {
    this.update();
  }

  componentWillReceiveProps(nextProps) {
    this.setState({data: nextProps.data.outgoingOrders}, () => {
        if (!nextProps.data.outgoingOrders.find(object => object.order.id === this.state.lastOrderId)) {
            this.setState({ expanded: {} });
        }
    })
  }

  update() {
    this.setState({
        name: this.props.data.name,
        data: this.props.data.outgoingOrders,
        fromContactInfo: this.props.data.fromContactInfo,
        toContactInfo: this.props.data.toContactInfo,
        locationType: this.props.data.locationType
      })
  }

  forceOutgoingConfirmation(order, props) {
    let params = {
        orderIds: JSON.parse('[' + order.id + ']'),
        wheelOrderIds: JSON.parse('[' + props.id + ']'),
        wheelChangerId: parseInt(Config.api.getWheelChangerId(), 10),
    }

    this.setState({ lastOrderId: order.id })
      
    axios.post(Config.api.getDomain() + 'order/forceOutgoingConfirmation', params, Config.api.getConfig())
        .then(response => {
            this.props.updateTable();
        })
        .catch(error => {
            console.log(error)
        })
  }

  sendBackWheel(order, props) {
    let params = {
        orderIds: JSON.parse('[' + order.id + ']'),
        wheelOrderIds: JSON.parse('[' + props.id + ']'),
        wheelChangerId: parseInt(Config.api.getWheelChangerId(), 10),
    }

    this.setState({ lastOrderId: order.id })
      
    axios.post(Config.api.getDomain() + 'order/sendBackWheel', params, Config.api.getConfig())
        .then(response => {
            this.props.updateTable();
        })
        .catch(error => {
            console.log(error)
        })
  }

  render() {
    return (
      <div className="outgoing">
        <h2>{this.props.title}</h2>
          <ReactTable
            data={this.state.data}
            loadingText="Laddar..."
            minRows="0"
            pageSize="200"
            className="need-confirm-ordertable"
            showPagination={false}
            noDataText="Inga hjul hittades"
            expanded={this.state.expanded}
            onExpandedChange={(newExpanded, index, event) => {
              // Sätter states för att kunna styla hela rowen
              const expanded = this.state.expanded
              expanded[index] = !expanded[index]
              this.setState({ expanded })
            }}
            columns={[
              {
                Header: "Ordertid",
                accessor: "order.transitDate",
                Cell: props => moment(props.value).format('YYYY-MM-DD - HH:mm'),
                width: 150
              },
              {
                Header: "Ordernummer",
                accessor: "order.id",
              },
              {
                Header: "Sändningsnummer",
                accessor: "order.shippingNo",
              },
              {
                Header: "Antal hjulset",
                accessor: "wheelSets",
              },
              {
                Header: "Antal pallar",
                accessor: "pallets"
              },
              {
                Header: "Antal kg",
                accessor: "weight",
                Cell: props => props.value + 'kg'
              },
              {
                Header: "Visa",
                expander: true,
                width: 65,
                style: {
                  cursor: "pointer",
                  fontSize: 16,
                  padding: "9px 0",
                  textAlign: "center",
                  userSelect: "none"
                },
              }
            ]}
            SubComponent={ row => {
              const columns = [
                {
                    Header: "Regnr",
                    accessor: "wheel.regNo",
                },
                {
                    Header: "Hjultyp",
                    accessor: "wheel.wheeltype.name",
                },
                {
                    Header: "Notis",
                    accessor: "wheel.wheelStatus.name",
                }
              ];

              if (isAdmin() && this.state.locationType === 3) {
                  columns.push(
                    {
                        Header: "",
                        Cell: props => {
                            return (
                                <button
                                    className='btn white'
                                    onClick={this.forceOutgoingConfirmation.bind(this, row.original.order, props.original)}
                                >
                                    Tvinga bekräfta
                                </button>
                            )
                        }
                    },
                    {
                        Header: "",
                        Cell: props => {
                        return (
                            <button
                                className='btn white'
                                onClick={this.sendBackWheel.bind(this, row.original.order, props.original)}
                            >
                                Skicka tillbaka
                            </button>
                        )
                        }
                    }
                )
              }

              return (
                <div
                  className='reacttable-inner-wrapper'
                  id="data-to-print"
                >
                  <div className='row'>

                    <div className='comment'>
                      <span className='bold'>Kommentar: </span>
                      {row.original.order.orderComment}
                    </div>
                    <button
                      className='btn white'
                      onClick={printDocument.bind(this, {
                        ...row.original,
                        fromContactInfo: this.state.fromContactInfo,
                        toContactInfo: this.state.toContactInfo,
                        pdfType:"outgoing"})}
                    >
                      <i className="fal fa-print"></i>Skriv ut kvittens
                    </button>
                  </div>

                  <ReactTable
                    data={row.original.order.wheelOrders}
                    loading={this.state.loading}
                    loadingText="Laddar..."
                    className="need-confirm-ordertable inner"
                    showPagination={false}
                    noDataText="Inga hjul hittades"
                    minRows="0"
                    pageSize="200"
                    columns={columns}
                  />
                </div>
              )
            }}
            getTrProps={(state, rowInfo, column, instance) => {
              return {
                // onClick: (e) => {
                //   console.log(instance)
                // },
                id: 'order-index-' + rowInfo.index,
                style: {
                  background: this.state.expanded[rowInfo.index] ? '#d1f3ff' : '#fff'
                }
              }
            }}
          />
      </div>
    )
  }
}



/**
 * Map state to properties
 */
const mapStateToProps = (state) => {
  return {
      refresh: state.refresh
  };
};

/**
* Map actions to properties
*/
const mapDispatchToProps = (dispatch) => {
  return {
      setTrue: (key) => dispatch(setTrue(key))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ThisStationTable)


// WEBPACK FOOTER //
// ./src/components/Outgoing/ThisStationTable.js